import React from "react";
import AboutImg from "../../assets/img/about/AboutImg.webp";

import {
  ServicesCircleIcon,
  ServicesCloudIcon,
  ServicesHomeIcon,
  ServicesMobileIcon,
} from "../common/Icons";
const About = () => {
  return (
    <>
      <section
        className="open_overlay_sections_none py-4 py-lg-5 mt-3"
        id="about"
      >
        <div className="container">
          <div className="text-center mb-2 mb-lg-5">
            <h2 className="d-inline main_heading px-3 py-2 bg_red mb-0">
              About Us
            </h2>
          </div>
          <div className="row justify-content-center justify-content-lg-between align-items-center">
            <div
              className="col-lg-6 mb-4 mb-lg-0"
              data-aos="fade-up-right"
              data-aos-duration="1500"
            >
              <div>
                <div className="d-flex mb-3 mb-lg-4 mt-5 card_shadow p-3">
                  <div>
                    <span>
                      <ServicesCloudIcon />
                    </span>
                  </div>
                  <div>
                    <h2 className="main_para font-md fw-semibold">
                      Eget cras odio proin vitae. Quis nullam.
                    </h2>
                    <p className="main_para mb-0">
                      Ipsum sed augue ac aliquam purus pharetra amet, adipiscing
                      ipsum. Quisque et nulla duis turpis cursus velit, ipsum
                      volutpat.
                    </p>
                  </div>
                </div>
                <div className="d-flex mb-3 mb-lg-4 card_shadow p-3">
                  <div>
                    <span>
                      <ServicesMobileIcon />
                    </span>
                  </div>
                  <div className="ms-3">
                    <h2 className="main_para font-md fw-semibold">
                      Montes, velit mauris sagittis
                    </h2>
                    <p className="main_para mb-0">
                      Ornare vel amet lacus dui sem. Sociis leo adipiscing sit
                      neque tristique est gravida. Pellentesque ut nunc aenean
                      condimentum.
                    </p>
                  </div>
                </div>
                <div className="d-flex mb-3 mb-lg-4 card_shadow p-3">
                  <div>
                    <span>
                      <ServicesCircleIcon />
                    </span>
                  </div>
                  <div>
                    <h2 className="main_para font-md fw-semibold">
                      Viverra felis, vitae ac et.
                    </h2>
                    <p className="main_para mb-0">
                      Turpis diam dolor habitasse viverra. Nisl, libero platea
                      phasellus egestas. Purus ultricies leo eros, diam. Vitae
                      sit cras vel sit ullamcorper.
                    </p>
                  </div>
                </div>
                <div className="d-flex mb-3 mb-lg-4 card_shadow p-3">
                  <div>
                    <span>
                      <ServicesHomeIcon />
                    </span>
                  </div>
                  <div>
                    <h2 className="main_para font-md fw-semibold">
                      Vulputate in blandit tortor
                    </h2>
                    <p className="main_para mb-0">
                      Vel mattis egestas lectus sed adipiscing dignissim. Mattis
                      vulputate varius et condimentum maecenas lacus. Sem nec
                      platea eu egestas.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-5"
              data-aos="fade-up-left"
              data-aos-duration="1500"
            >
              <div className="moving_animation_img">
                <img className="w-100" src={AboutImg} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
